export function encodeSearchTerm(term = "") {
    const termArray = term.split(" ");
    if (termArray.length == 1) {
        return encodeURI(term);
    }
    else {
        return termArray.map((term) => encodeURIComponent(term)).join("+");
    }
}
